// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__21lO0","selected":"Chip_selected__1AnDr"};